import styles from "./styles.module.scss";
import PhoneWidget from "./widget";

export {styles};
export default PhoneWidget;